var _path, _path2, _path3, _path4, _path5, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHorizontalLines(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 315,
    height: 142,
    viewBox: "0 0 315 142",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 0.928955L315 0.928983",
    stroke: "url(#paint0_linear_582_4561)",
    strokeWidth: 0.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0 35.9031L315 35.9031",
    stroke: "url(#paint1_linear_582_4561)",
    strokeWidth: 0.5
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M0 105.852L315 105.852",
    stroke: "url(#paint2_linear_582_4561)",
    strokeWidth: 0.5
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M0 70.929L315 70.929",
    stroke: "url(#paint3_linear_582_4561)",
    strokeWidth: 0.5
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M0 140.826L315 140.826",
    stroke: "url(#paint4_linear_582_4561)",
    strokeWidth: 0.5
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_582_4561",
    x1: 8.38978e-10,
    y1: 1.92693,
    x2: 315,
    y2: 1.92693,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#343440",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15625,
    stopColor: "#343440",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.510417,
    stopColor: "#2141C1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.854167,
    stopColor: "#343440",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#343440",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_582_4561",
    x1: 8.38978e-10,
    y1: 36.901,
    x2: 315,
    y2: 36.901,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#343440",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15625,
    stopColor: "#343440",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.510417,
    stopColor: "#2141C1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.854167,
    stopColor: "#343440",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#343440",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_582_4561",
    x1: 8.38978e-10,
    y1: 106.85,
    x2: 315,
    y2: 106.85,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#343440",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15625,
    stopColor: "#343440",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.510417,
    stopColor: "#DD2E2E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.854167,
    stopColor: "#343440",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#343440",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_582_4561",
    x1: 8.38978e-10,
    y1: 71.9269,
    x2: 315,
    y2: 71.9269,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#343440",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15625,
    stopColor: "#343440",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.510417,
    stopColor: "#DD2E2E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.854167,
    stopColor: "#343440",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#343440",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_582_4561",
    x1: 8.38978e-10,
    y1: 141.824,
    x2: 315,
    y2: 141.824,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#343440",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15625,
    stopColor: "#343440",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.510417,
    stopColor: "#DD2E2E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.854167,
    stopColor: "#343440",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#343440",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHorizontalLines);
export default __webpack_public_path__ + "static/media/Horizontal-lines.5289ac4e.svg";
export { ForwardRef as ReactComponent };